import React from "react";
import {
  Flame, Fish, BookOpen, Utensils, Flower2, Gift, Heart, Sparkles,
  Star, Sun, Leaf, Gem, Bell, ScrollText, HandHeart, Coins,
} from "lucide-react";

// On-brand palette (kept in sync with backend DEFAULT_PALETTE)
export const TAG_COLORS = [
  "#a8843b", "#c9a24a", "#4b8b6f", "#b5462f",
  "#4d5b8e", "#8a4b6b", "#3d8a8a", "#c98a2e",
];

// Preset icon keys -> lucide components (admin picks by key, stored as string)
export const ICON_MAP = {
  flame: Flame, fish: Fish, book: BookOpen, bowl: Utensils, flower: Flower2,
  gift: Gift, heart: Heart, sparkles: Sparkles, star: Star, sun: Sun,
  leaf: Leaf, gem: Gem, bell: Bell, scroll: ScrollText, hand: HandHeart, coins: Coins,
};

export const ICON_OPTIONS = Object.keys(ICON_MAP);

export function TagIcon({ name, className = "h-3.5 w-3.5" }) {
  const Cmp = ICON_MAP[name];
  if (!Cmp) return null;
  return <Cmp className={className} />;
}

// Given a hex colour, return inline styles for a tinted "outline" badge/chip.
export function tagChipStyle(color, active) {
  const c = color || "#a8843b";
  if (active) return { backgroundColor: c, borderColor: c, color: "#fff" };
  return { backgroundColor: `${c}1a`, borderColor: `${c}66`, color: c };
}
